import React from 'react'
import Template from './template'

const Mp3 = ({ viewBox }) => (
  <Template viewBox={viewBox}>
    <path
      style={{ fill: '#E9E9E0' }}
      d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074
		c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
    />
    <polygon
      style={{ fill: '#D9D7CA' }}
      points="37.5,0.151 37.5,12 49.349,12 	"
    />
    <path
      style={{ fill: '#7D6599' }}
      d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
    />
    <path
      style={{ fill: '#C8BDB8' }}
      d="M35.67,14.986c-0.567-0.796-1.3-1.543-2.308-2.351c-3.914-3.131-4.757-6.277-4.862-6.738V5
		c0-0.553-0.447-1-1-1s-1,0.447-1,1v1v8.359v9.053h-3.706c-3.882,0-6.294,1.961-6.294,5.117c0,3.466,2.24,5.706,5.706,5.706
		c3.471,0,6.294-2.823,6.294-6.294V16.468l0.298,0.243c0.34,0.336,0.861,0.72,1.521,1.205c2.318,1.709,6.2,4.567,5.224,7.793
		C35.514,25.807,35.5,25.904,35.5,26c0,0.43,0.278,0.826,0.71,0.957C36.307,26.986,36.404,27,36.5,27c0.43,0,0.826-0.278,0.957-0.71
		C39.084,20.915,37.035,16.9,35.67,14.986z M26.5,27.941c0,2.368-1.926,4.294-4.294,4.294c-2.355,0-3.706-1.351-3.706-3.706
		c0-2.576,2.335-3.117,4.294-3.117H26.5V27.941z M31.505,16.308c-0.571-0.422-1.065-0.785-1.371-1.081l-1.634-1.34v-3.473
		c0.827,1.174,1.987,2.483,3.612,3.783c0.858,0.688,1.472,1.308,1.929,1.95c0.716,1.003,1.431,2.339,1.788,3.978
		C34.502,18.515,32.745,17.221,31.505,16.308z"
    />
    <g>
      <path
        style={{ fill: '#FFFFFF' }}
        d="M22.4,42.924h1.668V53H22.4v-6.932l-2.256,5.605h-1.449l-2.27-5.605V53h-1.668V42.924h1.668
			l2.994,6.891L22.4,42.924z"
      />
      <path
        style={{ fill: '#FFFFFF' }}
        d="M28.211,53H26.57V42.924h2.898c0.429,0,0.853,0.068,1.271,0.205s0.795,0.342,1.128,0.615
			s0.602,0.604,0.807,0.991s0.308,0.822,0.308,1.306c0,0.511-0.087,0.973-0.26,1.388s-0.415,0.764-0.725,1.046
			s-0.684,0.501-1.121,0.656s-0.921,0.232-1.449,0.232h-1.217V53z M28.211,44.168v3.992h1.504c0.2,0,0.398-0.034,0.595-0.103
			s0.376-0.18,0.54-0.335s0.296-0.371,0.396-0.649s0.15-0.622,0.15-1.032c0-0.164-0.022-0.354-0.068-0.567s-0.139-0.419-0.28-0.615
			s-0.34-0.36-0.595-0.492s-0.593-0.198-1.012-0.198H28.211z"
      />
      <path
        style={{ fill: '#FFFFFF' }}
        d="M38.615,47.695c0.21,0.027,0.426,0.096,0.649,0.205s0.431,0.265,0.622,0.465
			s0.351,0.444,0.479,0.731s0.191,0.617,0.191,0.991c0,0.456-0.066,0.85-0.198,1.183s-0.299,0.608-0.499,0.827
			s-0.426,0.395-0.677,0.526s-0.494,0.23-0.731,0.294s-0.453,0.104-0.649,0.123s-0.349,0.027-0.458,0.027
			c-0.766,0-1.369-0.053-1.812-0.157s-0.75-0.212-0.923-0.321l0.369-1.176c0.082,0.046,0.159,0.096,0.232,0.15
			s0.178,0.107,0.314,0.157s0.328,0.091,0.574,0.123s0.583,0.048,1.012,0.048c0.629,0,1.099-0.171,1.408-0.513
			s0.465-0.772,0.465-1.292c0-0.492-0.142-0.907-0.424-1.244s-0.697-0.506-1.244-0.506h-1.395h0.014l-0.014-1.107h0.93
			c0.2,0,0.403-0.005,0.608-0.014s0.398-0.06,0.581-0.15s0.333-0.246,0.451-0.465s0.178-0.533,0.178-0.943
			c0-0.164-0.014-0.337-0.041-0.52s-0.103-0.351-0.226-0.506s-0.303-0.28-0.54-0.376s-0.565-0.144-0.984-0.144
			s-0.754,0.039-1.005,0.116s-0.439,0.139-0.567,0.185l-0.479-1.23c0.219-0.063,0.49-0.132,0.813-0.205s0.791-0.109,1.401-0.109
			c0.429,0,0.834,0.053,1.217,0.157s0.718,0.271,1.005,0.499s0.515,0.52,0.684,0.875s0.253,0.774,0.253,1.258
			c0,0.282-0.05,0.54-0.15,0.772s-0.228,0.436-0.383,0.608s-0.328,0.316-0.52,0.431S38.779,47.659,38.615,47.695z"
      />
    </g>
  </Template>
)

export default Mp3



// WEBPACK FOOTER //
// ./src/components/Svg/mp3.js